// extracted by mini-css-extract-plugin
module.exports = {"container":"service_container__au3XD","header":"service_header__cfGxE","cardContainer":"service_cardContainer__NxGc2"};